import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import routes from 'src/routes';
import Page from 'src/components/Page';

function GettingStartedPage() {

    return <Page header="Getting started">

        <h2>What is an AuthKey?</h2>
        <p>
            An AuthKey is a short-lived payment session.  It is designed to manage the different stages involved in processing a payment or managing a token.  The minimum requirement for processing a payment with an AuthKey are listed below:
            <ul>
                <li>Create an AuthKey - To begin the payment session.  See <Link to={routes.api.spec + "#tag/TxnAuthkey/operation/TxnAuthkey_CreateAuthkey"}>Create a transaction authkey</Link> for details.</li>
                <li>Attach Transaction or Token Details - Basic information about the transaction, including Amount, Currency, Biller Code, Action etc.  See <Link to={routes.api.spec + "#tag/TxnAuthkey/operation/TxnAuthkey_AttachTxnDetails"}>Attach txn details</Link> or <Link to={routes.api.spec + "#tag/TokenAuthkey/operation/TokenAuthkey_AttachTokenDetails"}>Attach token details</Link> for details.</li>
                <li>Pick one of these approaches for collecting the payment method from the cardholder:
                    <ul>
                        <li>2-party</li>
                        <li>JavaScript Simple</li>
                        <li>JavaScript Advanced</li>
                        <li>Iframe fields</li>
                    </ul>
                </li>
                <li>Process payment or token - The last step is to initiate the payment or create the token. See <Link to={routes.api.spec + "#tag/TxnAuthkey/operation/TxnAuthkey_Process"}>Process transaction</Link> or <Link to={routes.api.spec + "#tag/TokenAuthkey/operation/TokenAuthkey_Process"}>Process token</Link> for details.</li>
            </ul>
        </p>
        <p>
            There are more features that could be attached to an AuthKey to enhance the payment experience (not available for token management), such as:
            <ul>
                <li><Link to={routes.api.spec + "#tag/TxnAuthkey/operation/TxnAuthkey_AttachFraudScreening"}>Fraud screening details</Link> - Please contact your Relationship Manager for more details.</li>
                <li><Link to={routes.api.spec + "#tag/TxnAuthkey/operation/TxnAuthkey_AttachCustomerDetails"}>Customer Details</Link> - Collect customer details.</li>
                <li><Link to={routes.api.spec + "#tag/TxnAuthkey/operation/TxnAuthkey_AttachOrderDetails"}>Order Details</Link> - Collect order details.</li>
                <li><Link to={routes.api.spec + "#tag/TxnAuthkey/operation/TxnAuthkey_AttachStatementDescriptor"}>Statement Descriptor</Link> - Collect statement descriptor.</li>
                <li><Link to={routes.api.spec + "#tag/TxnAuthkey/operation/TxnAuthkey_SetupAuthenticationIframe"}>Setup authentication iframe</Link> - Authenticate Payment using 3D Secure.</li>
            </ul>
        </p>

        <p>
            Visit <Link to={routes.api.txn.authkey.flow}>Transaction flow</Link> and <Link to={routes.api.token.authkey.flow}>Token flow</Link> to visualise AuthKey processing.
        </p>

        <h2>Sample iFrame implementation</h2>
        <p>
            To get a taste on how to develop a basic Iframe implementation you can follow along in the <Link exact to={routes.getstarted.quickstart}>Quick Start</Link> guide.            
        </p>
        <p>
            iFrame is a popular payment method used by most of our Merchants.  iFrame is the most flexible, allowing you to style and position each payment element as you wish.
        </p>

        <h2>Payment Card Industry Data Security Standard (PCI DSS)</h2>
        <p>
            PCI DSS is a security standard with the aim of managing payment card details to prevent fraud.  Please contact your Relationship Manager to discuss which payment method best suites 
            your business requirements.  For information about PCI DSS you may wish to visit their <a href="https://www.pcisecuritystandards.org/" target="_blank" rel="noopener noreferrer">website</a>.
        </p>
    </Page>

}

export default GettingStartedPage;